/* eslint-disable */
import stripIndent from '../../Vendor/strip-indent';

/**
 * Thrown when `createHeaders()` is called when no user is currently logged in
 * @export
 * @class AuthCouldNotCreateHeadersWhilstNotLoggedInError
 * @extends {Error}
 */
export class AuthCouldNotCreateHeadersWhilstNotLoggedInError extends Error {
  /**
   * Creates an instance of AuthCouldNotCreateHeadersWhilstNotLoggedInError
   * @param {string} message The Error `message`
   * @memberof AuthCouldNotCreateHeadersWhilstNotLoggedInError
   */
  constructor(message) {
    super(message);
    this.name = `AuthCouldNotCreateHeadersWhilstNotLoggedInError`;
  }
}

/**
 * Called when `createHeaders()` is called when no user is currently logged in
 * @returns {never} never
 */
const throwAuthCouldNotCreateHeadersWhilstNotLoggedInError = () => {
  throw new AuthCouldNotCreateHeadersWhilstNotLoggedInError(
    stripIndent(`
    Could not create auth headers when no user is currently logged in.
    `),
  );
};

export default throwAuthCouldNotCreateHeadersWhilstNotLoggedInError;
